function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { keyframes } from '@emotion/css';
export var rotate = /*#__PURE__*/keyframes(process.env.NODE_ENV === "production" ? {
  name: "1b2444z",
  styles: "0%{transform-origin:50% 50%;transform:rotate(0);}100%{transform-origin:50% 50%;transform:rotate(360deg);}"
} : {
  name: "1b2444z",
  styles: "0%{transform-origin:50% 50%;transform:rotate(0);}100%{transform-origin:50% 50%;transform:rotate(360deg);}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});